import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum MeetingStatusIds {
  OPEN = 1,
  CLOSED = 2,
}

export function getMeetingStatii(): ISelectItem[] {
  return [
    { id: MeetingStatusIds.OPEN, label: 'Open' },
    { id: MeetingStatusIds.CLOSED, label: 'Closed' },
  ]
}

export const getMeetingStatusByLabel = getItemByLabelFactory(getMeetingStatii)
export const getMeetingStatusById = getItemByIdFactory(getMeetingStatii)
